(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerAddController', [
            'MW.ContactManager.ContactManagerNavigationService'
        ])
        .controller('ContactManagerAddController', [
            'ContactManagerNavigationService',
            'breadcrumbs',
            'isInfluencerDatabaseEntitled',
            ContactManagerAddController
        ]);

    function ContactManagerAddController(ContactManagerNavigationService, breadcrumbs, isInfluencerDatabaseEntitled) {
        this.ContactManagerNavigationService = ContactManagerNavigationService;
        this.breadcrumbs = breadcrumbs;
        this.isInfluencerDatabaseEntitled = isInfluencerDatabaseEntitled;
    }

    ContactManagerAddController.prototype.importContacts = function importContacts() {
        this.ContactManagerNavigationService.goToImport();
    };

    ContactManagerAddController.prototype.manuallyCreate = function manuallyCreate() {
        this.ContactManagerNavigationService.goToCreate();
    };

    ContactManagerAddController.prototype.goToSearch = function goToSearch() {
        this.ContactManagerNavigationService.goToSearch();
    };

    ContactManagerAddController.prototype.searchByKeywordForContacts = function searchByKeywordForContacts() {
        this.ContactManagerNavigationService.goToKeywordSearch();
    };

    ContactManagerAddController.prototype.searchDirectoryForContacts = function searchDirectoryForContacts() {
        this.ContactManagerNavigationService.goToDirectorySearch();
    };

}());
